import { Grid, TextField } from '@material-ui/core';
import React from 'react';
import SearchIcon from '@material-ui/icons/Search';

const ShareFlagsSearchInput = ({ searchQuery, handleInputChange }) => {
  return (
    <Grid className="share-flags-modal__search" container alignItems="flex-end">
      <Grid item className="share-flags-modal__search-icon">
        <SearchIcon fontSize="large" />
      </Grid>
      <Grid item style={{ width: '90%' }}>
        <TextField
          style={{ width: '90%' }}
          className="share-flags-modal__search-textfield"
          placeholder="Search by Name, Email or Group"
          inputProps={{ 'aria-label': 'search users' }}
          value={searchQuery}
          onChange={handleInputChange}
        />
      </Grid>
    </Grid>
  );
};

export default ShareFlagsSearchInput;
